import React from 'react'

const FastForwardIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_11875_4551)'>
        <path
          d='M3.125 5.61312V14.3866C3.12595 14.497 3.1565 14.6052 3.21346 14.6999C3.27042 14.7945 3.35172 14.8722 3.44888 14.9247C3.54604 14.9773 3.65551 15.0029 3.76591 14.9988C3.8763 14.9947 3.98357 14.961 4.07656 14.9014L10.9664 10.5147C11.0532 10.4597 11.1247 10.3837 11.1743 10.2937C11.2238 10.2037 11.2498 10.1026 11.2498 9.99984C11.2498 9.89709 11.2238 9.79602 11.1743 9.706C11.1247 9.61599 11.0532 9.53996 10.9664 9.485L4.07656 5.09828C3.98357 5.03864 3.8763 5.00502 3.76591 5.00092C3.65551 4.99681 3.54604 5.02237 3.44888 5.07494C3.35172 5.12751 3.27042 5.20516 3.21346 5.29982C3.1565 5.39447 3.12595 5.50266 3.125 5.61312Z'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.25 5.61312V14.3866C11.251 14.497 11.2815 14.6052 11.3385 14.6999C11.3954 14.7945 11.4767 14.8722 11.5739 14.9247C11.671 14.9773 11.7805 15.0029 11.8909 14.9988C12.0013 14.9947 12.1086 14.961 12.2016 14.9014L19.0914 10.5147C19.1782 10.4597 19.2497 10.3837 19.2993 10.2937C19.3488 10.2037 19.3748 10.1026 19.3748 9.99984C19.3748 9.89709 19.3488 9.79602 19.2993 9.706C19.2497 9.61599 19.1782 9.53996 19.0914 9.485L12.2016 5.09828C12.1086 5.03864 12.0013 5.00502 11.8909 5.00092C11.7805 4.99681 11.671 5.02237 11.5739 5.07494C11.4767 5.12751 11.3954 5.20516 11.3385 5.29982C11.2815 5.39447 11.251 5.50266 11.25 5.61312Z'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_11875_4551'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FastForwardIcon
